import React from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import './OralProphylaxis.css';

const OralProphylaxis = () => {
    const pricing = [
        { type: "Mild", price: "₱1,000 - ₱1,500" },
        { type: "Moderate", price: "₱1,500 - ₱2,000" },
        { type: "Severe", price: "₱3,000" },
        { type: "Deep Scaling", price: "₱3,500 - ₱4,000" }
    ];

    return (
        <>
        <Header />
        <div className="oral-prophylaxis-container">
            <div className="oral-prophylaxis-content">
                <h1>ORAL PROPHYLAXIS</h1>
                <p>
                    It removes tartar and plaque build-up from the surfaces of the teeth as well 
                    as those hidden in between and under the gums. The dentist uses a scaler, 
                    a type of hand instrument, to remove the plaque and tartar.
                </p>
                <h2>Pricing</h2>
                <table className="oral-prophylaxis-table">
                        <thead>
                            <tr>
                                <th>Type of Surgery</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pricing.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.type}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ContactUsFooter />
        </>
    );
};


export default OralProphylaxis;